import { useCombinedBenchmarkRequirements } from '@cibo/programs'

export const useAllRequirements = () => {
  const profileRequirements = useCombinedBenchmarkRequirements('profile')
  const prequalifyRequirements = useCombinedBenchmarkRequirements('prequalify')
  const enrollmentRequirements = useCombinedBenchmarkRequirements('enrollment')

  return {
    isLoading:
      profileRequirements.isLoading ||
      prequalifyRequirements.isLoading ||
      enrollmentRequirements.isLoading,
    data: [
      ...(prequalifyRequirements.data || []),
      ...(profileRequirements.data || []),
      ...(enrollmentRequirements.data || []),
    ],
  }
}
